import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'value', // USEREMO QUESTO NOME NEL DOM
    pure: false
})
export class Value implements PipeTransform {
    transform(value: number) {
        if (value !== 0) {
            return value.toFixed(7);
        } else {
            return 0;
        }
    }
}